<template>
  <div>
    <div class="myCanvasBox">
      <canvas id="myCanvas" width="620" height="877">
        您的浏览器不支持预览，请切换浏览器。
      </canvas>
      <div class="simkai">11</div>
    </div>
    <div class="top">
      <el-button type="primary" @click="importclick" :disabled="disable">导出</el-button>
      <el-button type="primary" @click="importdialogclick" :disabled="disaaa">导入</el-button>
      <el-button type="primary" @click="dimensionplottingclick" :disabled="disable">标注打印</el-button>
      <div style="display: inline-block; margin-left: 10px;">
        培训主题：
        <el-select v-model="topicsValue" placeholder="请选择" @change="topicsChange">
          <el-option v-for="(item, index) in topicsOptions" :key="index" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="content">
      <el-table v-loading="loadingTable" :data="tableData" style="width: 80vw" border
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center">
        </el-table-column>
        <el-table-column type="index" label="No." align="center" :index="indexAdd">
        </el-table-column>
        <el-table-column prop="area" label="省份" align="center">
        </el-table-column>
        <el-table-column prop="schoolName" label="院校" align="center" :show-overflow-tooltip=true>
        </el-table-column>
        <el-table-column prop="name" label="证书姓名" align="center">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" align="center">
        </el-table-column>
        <el-table-column prop="trainTime" label="培训时间" align="center">
        </el-table-column>
        <el-table-column prop="subject" label="培训主题" align="center" :show-overflow-tooltip=true>
        </el-table-column>
        <el-table-column prop="certificate" label="证书名称" align="center" :show-overflow-tooltip=true>
        </el-table-column>
        <el-table-column prop="certificateNumber" label="证书编号" align="center" :show-overflow-tooltip=true>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="getCertificateInfo(scope.row)">详情</el-button>
            <el-button size="mini" type="primary" @click="getdelect(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination style="margin-left:30%;margin-top: 10px;" background @size-change="handleSizeChange"
          @current-change="currentchange" :page-sizes="[10, 20, 30, 40, 50, 100, 200]" :page-size.sync="limit"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <el-dialog title="标注打印" :visible.sync="dimensionplotting" width="30%" @close="dimensionplottingcancle('ruleForm')"
        :close-on-click-modal=false>
        <el-form :inline="true" :model="formInline" class="demo-form-inline" :rules="rules" ref="formInline"
          style="margin-left:5%">
          <el-form-item label="是否打印电子版" style="display:block">
            <el-select v-model="formInline.electronic" placeholder="">
              <el-option label="是" value=1></el-option>
              <el-option label="否" value=2></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否打印纸质版" style="display:block">
            <el-select v-model="formInline.paperversion" placeholder="">
              <el-option label="是" value=1></el-option>
              <el-option label="否" value=2></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" style="display:block;margin-left: 15px;">
            <el-input v-model="formInline.remarks" placeholder="" style="width:217px"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dimensionplotting = false">取 消</el-button>
          <el-button type="primary" @click="dimensionplottingok('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="导入" :visible.sync="importdialog" width="30%" @close="importdialogcancle('ruleForm')"
        :close-on-click-modal=false>
        <el-upload class="upload-demo" ref="upload" :action="endpoint" :file-list="listArrfile" :limit="1"
          :http-request="uploadFile" accept=".xls,.pdf,.ppt,.doc,.docx,.xlsx">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div style="margin-top:20px">
          <el-select v-model="moudulearr" placeholder="请选择" style="width:300px" @change="handlevel">
            <!-- <el-option label="全选" value="quanxuan"></el-option> -->
            <el-option v-for="item in options" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </div>
        <el-progress :percentage="percentage" style="margin-top:20px" v-show="percentageif != false"></el-progress>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancle11">取 消</el-button>
          <el-button type="primary" @click="importdialogok('ruleForm')"
            :disabled="!optionsid || !filepro || updisabled">确
            定</el-button>
          <!-- :disabled="!filepro" -->
        </span>
      </el-dialog>
      <el-dialog title="详情" :visible.sync="detailsdialog" width="70%" @close="detailsdialogcancle('ruleForm')"
        :close-on-click-modal=false>
        <el-row>
          <el-col :span="10">
            <!-- <canvas id="myCanvas_dist" width="620" height="877" style="margin-left: 1%;margin-top: 5%;">
              您的浏览器不支持预览，请切换浏览器。
            </canvas> -->
            <!-- <a></a> -->
            <!-- <img :src="src" alt="" width="650px" height="500px" style="margin-left: 1%;margin-top: 5%;" /> -->
            <!-- <img :src="src" alt="" width="620px" height="877px" style="margin-left: 1%;margin-top: 5%;" /> -->
            <el-image :src="src" style="margin-left: 1%;margin-top: 5%;width: 701.6px;" :preview-src-list="[src]">
            </el-image>

          </el-col>
          <el-col :span="14">
            <el-form :inline="true" :model="model" class="demo-form-inline" :rules="rules" ref="formInline"
              style="margin-left:30%">
              <el-form-item label="省份" style="margin-left:28px">
                <el-input v-model="model.area" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="院校" style="display:block;margin-left: 28px;">
                <el-input v-model="model.schoolName" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="证书姓名" style="display:block;">
                <el-input v-model="model.name" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="手机号" style="display:block;margin-left: 15px;">
                <el-input v-model="model.mobile" placeholder="" style="width:300px;" type="input" disabled></el-input>
              </el-form-item>
              <el-form-item label="培训时间" style="display:block;">
                <el-input v-model="model.trainTime" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="培训主题" style="display:block;">
                <el-input v-model="model.subject" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="主讲教师" style="display:block;">
                <el-input v-model="model.lecturer" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="证书名称" style="display:block;">
                <el-input v-model="model.certificate" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="证书编号" style="display:block;">
                <el-input v-model="model.certificateNumber" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="负责人" style="display:block;margin-left: 15px;">
                <el-input v-model="model.functionary" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="是否打印电子证书" style="display:block;margin-left: -54px;">
                <el-input v-model="model.isElectronic" placeholder="" style="width:300px;" disabled></el-input>
              </el-form-item>
              <el-form-item label="是否打印纸质" style="display:block;margin-left: -25px;">
                <el-input v-model="model.isPapery" placeholder="" style="width:300px; " disabled></el-input>
              </el-form-item>
              <el-form-item label="备注" style="display:block;margin-left: 31px;">
                <el-input v-model="model.remarks" placeholder="" style="width:300px; " disabled></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detailsdialog = false">取 消</el-button>
          <el-button type="primary" @click="detailsdialogok('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import api from '../router/api'
import JSZip from 'jszip';
//华为云引入
import HWuplode from "../common/HUAWEIYUN";
import { Loading, Select } from 'element-ui';
export default {
  components: {

  },
  data() {
    return {
      downloadIndex: 0,
      loadingTable: false,
      topicsOptions: [],
      tableSelector: [],
      topicsValue: '',
      //进度条隐藏判定条件
      percentageif: false,
      //取进度
      timera: 0.0,
      timer: 0,
      percentage: 0,
      model: {
        area: '',
        schoolName: '',
        name: '',
        mobile: '',
        trainTime: '',
        subject: '',
        lecturer: '',
        certificate: '',
        certificateNumber: '',
        functionary: '',
        isElectronic: '',
        isPapery: '',
        remarks: '',
      },
      //图片回显
      src: '',
      pageCount: 0,
      page: 1,
      limit: 10,
      total: 0,
      tableData: [],
      //标注打印按钮
      dimensionplotting: false,
      //导入按钮弹窗
      importdialog: false,
      detailsdialog: false,
      //禁用标注打印按钮
      disable: true,
      disaaa: false,
      //标注打印表单
      formInline: {
        //电子版
        electronic: '',
        //纸质版
        paperversion: '',
        //备注
        remarks: '',
      },
      //校验
      rules: {
        // tag: [{ required: true, message: "请输入标签1", trigger: "blur" },
        // { max: 20, message: "最多不可超过20个字", trigger: "blur" }],
      },
      endpoint: "obs.cn-north-4.myhuaweicloud.com",
      listArrfile: [],
      hwyimg: '',
      moudulearr: [],
      options: [],
      //上传文件
      filepro: null,
      id: [], //id
      myidArr: [], //参数
      optionsid: null,
      // ids:'',
      code: 'ww4660c5e8aa980fa4',
      updisabled: false,
    }
  },
  created() {
    this.getData();
    this.getSubject();
  },
  methods: {
    getSubject() {
      this.$get('getSubject').then(res => {
        this.topicsOptions = res.data;
        this.topicsOptions.unshift('全部');
      })
    },
    topicsChange(e) {
      this.subject = e == '全部' ? '' : e;
      this.$post("datacord", { page: this.page, limit: this.limit, subject: this.subject }).then((res) => {
        this.tableData = res.data.list
        this.total = res.data.total
      });
    },
    getData() {
      this.loadingTable = true;
      this.$post("datacord", {
        page: this.page,
        limit: this.limit,
        subject: this.subject
      }).then((res) => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.pageCount = this.total / 10,
          this.loadingTable = false;
      }).catch((err) => {
        this.loadingTable = false;
        this.$message.error("获取失败");
      })
    },

    async importclick() {
      this.downloadIndex = 0;
      const that = this;
      const loadingText = `正在打包下载证书文件，共${this.tableSelector.length}条下载项，当前进度：0%，请耐心等待`;
      const loading = this.$loading({
        lock: true,
        text: loadingText,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const zip = new JSZip();
      const folder = zip.folder(`证书${this.tableSelector.length}条(${new Date()})`);
      let promises = [];


      const taskLength = this.tableSelector.length;
      async function runTask() {
        if (that.downloadIndex > taskLength - 1) return runDownload();
        const task = fetch('https' + that.tableSelector[that.downloadIndex].url.substring(4))
          .then(response => response.blob())
          .then(blob => {
            const filename = `${that.downloadIndex + 1}. ${that.tableSelector[that.downloadIndex].name}.jpg`;
            folder.file(filename, blob);
            that.downloadIndex++;
            const text = `正在打包下载证书文件，共${that.tableSelector.length}条下载项，当前进度：${parseInt(that.downloadIndex / that.tableSelector.length * 100)}%，请耐心等待`;
            loading.setText(text);
            runTask();
          })
        promises.push(task);
      }
      runTask();
      async function runDownload() {
        Promise.all(promises)
          .then(() => {
            zip.generateAsync({ type: 'blob' }).then(content => {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(content);
              link.download = `证书${that.tableSelector.length}条(${new Date()}).zip`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              loading.close();
              that.$message.success("下载成功")
            });
          });
      }
    },

    canvasFun(myObj) {
      var c = document.getElementById("myCanvas");
      var ctx = c.getContext("2d");
      var cW = c.offsetWidth; // 获取元素宽度
      var cH = c.offsetHeight; // 获取元素高度
      var imgObj = new Image();
      var imgW = '';
      var imgH = '';
      imgObj.crossOrigin = 'anonymous'; // 设置 crossOrigin 属性
      //加时间戳解决跨域问题
      // imgObj.src = 'http://statools.posedu.com.cn/model/weilai.png'
      imgObj.src = require('../assets/wljy.png');
      imgObj.onload = function () {
        imgW = imgObj.width;
        imgH = imgObj.height;
        ctx.drawImage(this, 0, 0, cW, imgH * cW / imgW);
        // 英文
        ctx.font = '19px PingFang';
        ctx.textAlign = 'center';
        ctx.fillText(myObj.typeEng, 310, 275);
        // 标题
        console.log("myObj.certificate.length", myObj.certificate.length);
        var mySize = parseInt(500 / myObj.certificate.length)
        ctx.font = '700 ' + (mySize > 50 ? 50 : mySize) + 'px simkai'
        ctx.textAlign = 'center';
        ctx.fillText(myObj.certificate, 310, 327);
        // 获奖人名称
        ctx.font = '700 25px simkai'
        ctx.textAlign = 'center';
        if (myObj.name.length == 2) {
          let mynameArr = myObj.name.split('')
          myObj.name = mynameArr[0] + '  ' + mynameArr[1]
          console.log("myObj.name", myObj.name);
        }
        ctx.fillText(myObj.name, 310, 385);

        // 获奖时间 
        ctx.font = '500 14px PingFang'
        ctx.textAlign = 'center';
        ctx.fillText('2023年10月10日', 190, 677);

        // 证书编号 
        ctx.font = '500 11px PingFang'
        ctx.textAlign = 'left';
        ctx.fillText('证书编号  CERTIFICATE NO：' + myObj.certificateNumber, 124, 740);

        var dataURL = c.toDataURL('image/jpeg', 1);
        console.log(dataURL);
        //图片下载
        if (window.navigator.msSaveOrOpenBlob) {
          console.log(123);
          const bstr = atob(dataURL.split(',')[1])
          let n = bstr.length
          const u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          const blob = new Blob([u8arr])
          window.navigator.msSaveOrOpenBlob(blob, myObj.name + '证书.jpeg')
        } else {
          console.log(456);
          // 这里就按照chrome等新版浏览器来处理
          const a = document.createElement('a')
          a.href = dataURL
          a.setAttribute('download', myObj.name + '证书.jpeg')
          a.click()
        }
      }


    },
    //点击复选框
    handleSelectionChange(val) {
      this.tableSelector = val;

      this.id = []
      this.myidArr = val
      for (let index = 0; index < val.length; index++) {
        this.id.push(val[index].id)
      }

      if (val.length != 0) {
        this.disable = false
      } else {
        this.disable = true
      }
    },
    //点击标注打印按钮
    dimensionplottingclick() {
      this.dimensionplotting = true
    },
    //标注打印确定按钮
    dimensionplottingok() {
      // isElectronic:,isPapery:,
      this.$post("setPrintCertificate", {
        ids: this.id + '',
        isElectronic: this.formInline.electronic,
        isPapery: this.formInline.paperversion,
        remark: this.formInline.remarks
      }).then((res) => {
        this.formInline.electronic = ''
        this.formInline.paperversion = ''
        this.formInline.remarks = ''
        this.getData()
      });
      this.dimensionplotting = false
    },
    //标注打印取消按钮
    dimensionplottingcancle() {
      this.formInline.electronic = ''
      this.formInline.paperversion = ''
      this.formInline.remarks = ''
      this.dimensionplotting = false
    },
    //点击导入按钮
    importdialogclick() {
      this.$get("getTemplateList").then((res) => {
        this.options = res.data
        console.log('2323', this.options)
      });
      this.importdialog = true
    },
    //点击切换模板
    handlevel(val) {
      for (let index = 0; index < this.options.length; index++) {
        if (this.options[index].name == val) {
          this.optionsid = this.options[index].id
        }
      }
      console.log('123', val)
    },
    //导入按钮取消
    importdialogcancle() {
      this.importdialog = false
      this.listArrfile = []
      this.moudulearr = []
      // this.options = []
    },
    //导入按钮确定
    importdialogok() {
      if (!this.filepro) return this.$message.error('请先上传');
      this.updisabled = true;
      this.options = []
      var filepro = {
        uid: this.filepro.uid,
        lastModified: this.filepro.lastModified,
        lastModifiedDate: this.filepro.lastModifiedDate,
        name: this.filepro.name,
        size: this.filepro.size,
        type: this.filepro.type,
        webkitRelativePath: this.filepro.webkitRelativePath,
      }
      axios({
        method: 'post',
        url: api.matchImportCertificate,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {
          file: this.filepro,
          templateId: this.optionsid
        },
        cache: false, //设置是否第二次是否从缓存中读取
        processData: false, //将数据类型序列换成application/x-www-form-urlencoded ，fasle表示关闭
        contentType: false //默认值为application/x-www-form-urlencoded，false表示关闭
      }).then(res => {
        this.file = null;
        this.optionsid = null;
        this.updisabled = true;
      }).catch(err => {
        // clearInterval(this.timer)
        // this.timer = null
      });
      this.percentageif = true
      this.timer = setInterval(this.percentFun, 3000);
    },
    percentFun() {
      this.$get("getProgress").then((res) => {
        console.log(res)
        this.timera = Number(res.data.current / res.data.sum * 100).toFixed(1)
        this.percentage = this.timera * 1
        if (this.percentage >= 100) {
          this.moudulearr = []
          this.listArrfile = []
          // 在此处之前执行隐藏进度条 
          this.percentageif = false
          this.$message.success('导入成功')
          this.importdialog = false
          this.getData()
          this.percentage = 0
          clearInterval(this.timer)
          // sessionStorage.setItem('percent', 0); //上传成功后把缓存中的进度清零
        }
      });
    },
    uploadFile(res) {
      this.filepro = res.file
    },

    currentchange(val) {
      this.page = val
      this.$post("datacord", { page: val, limit: this.limit, subject: this.subject }).then((res) => {
        this.tableData = res.data.list
      });
    },
    handleSizeChange(val) {
      this.getData();
    },
    // 序号排列
    indexAdd(index) {
      const page = this.page // 当前页码
      const pagesize = 10 // 每页条数
      return index + 1 + (page - 1) * pagesize
    },
    //点击详情页面
    getCertificateInfo(row) {
      // console.log(row)
      let id = row.id
      this.$get("getCertificateInfo", id).then((res) => {
        if (res.code == 200) {
          this.src = res.data.url
          this.model.area = res.data.area
          this.model.schoolName = res.data.schoolName
          this.model.name = res.data.name
          this.model.mobile = res.data.mobile
          this.model.trainTime = res.data.trainTime
          this.model.subject = res.data.subject
          this.model.lecturer = res.data.lecturer
          this.model.certificate = res.data.certificate
          this.model.certificateNumber = res.data.certificateNumber
          this.model.functionary = res.data.functionary
          this.model.remarks = res.data.remark
          this.model.typeEng = res.data.typeEng
          let max = res.data.isElectronic
          let min = res.data.isPapery
          if (max == '1') {
            max = '打印电子证书'
            this.model.isElectronic = max
          } else {
            max = '不打印'
            this.model.isElectronic = max
          }
          if (min == '1') {
            min = '打印纸质'
            this.model.isPapery = min
          } else {
            min = '不打印'
            this.model.isPapery = min
          }
          let that = this
          setTimeout(() => {
            var c = document.getElementById("myCanvas_dist");
            var ctx = c.getContext("2d");
            var cW = c.offsetWidth; // 获取元素宽度
            var cH = c.offsetHeight; // 获取元素高度
            var imgObj = new Image();
            var imgW = '';
            var imgH = '';
            imgObj.crossOrigin = 'anonymous'; // 设置 crossOrigin 属性
            //加时间戳解决跨域问题
            // imgObj.src = 'http://statools.posedu.com.cn/model/weilai.png'
            imgObj.src = require('../assets/wljy.png');
            imgObj.onload = function () {
              imgW = imgObj.width;
              imgH = imgObj.height;
              ctx.drawImage(this, 0, 0, cW, imgH * cW / imgW);
              // 英文
              ctx.font = '19px PingFang';
              ctx.textAlign = 'center';
              ctx.fillText(that.model.typeEng, 310, 275);
              // 标题
              console.log("that.model.certificate.length", that.model.certificate.length);
              var mySize = parseInt(500 / that.model.certificate.length)
              ctx.font = '700 ' + (mySize > 50 ? 50 : mySize) + 'px simkai'
              ctx.textAlign = 'center';
              ctx.fillText(that.model.certificate, 310, 327);
              // 获奖人名称
              ctx.font = '700 25px simkai'
              ctx.textAlign = 'center';
              if (that.model.name.length == 2) {
                let mynameArr = that.model.name.split('')
                that.model.name = mynameArr[0] + '  ' + mynameArr[1]
                console.log("that.model.name", that.model.name);
              }
              ctx.fillText(that.model.name, 310, 385);

              // 获奖时间 
              ctx.font = '500 14px PingFang'
              ctx.textAlign = 'center';
              ctx.fillText('2023年10月10日', 190, 677);

              // 证书编号 
              ctx.font = '500 11px PingFang'
              ctx.textAlign = 'left';
              ctx.fillText('证书编号  CERTIFICATE NO：' + that.model.certificateNumber, 124, 740);

              var dataURL = c.toDataURL('image/jpeg', 1);
              console.log(dataURL);
              //图片下载
              if (window.navigator.msSaveOrOpenBlob) {
                console.log(123);
                const bstr = atob(dataURL.split(',')[1])
                let n = bstr.length
                const u8arr = new Uint8Array(n)
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n)
                }
                const blob = new Blob([u8arr])
                window.navigator.msSaveOrOpenBlob(blob, that.model.name + '证书.jpeg')
              } else {
                console.log(456);
                // 这里就按照chrome等新版浏览器来处理
                const a = document.createElement('a')
                a.href = dataURL
                a.setAttribute('download', that.model.name + '证书.jpeg')
                a.click()
              }
            }


          }, 1000);
        }
      });
      this.detailsdialog = true
    },
    base64ImgtoFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    // 详情页面取消按钮
    detailsdialogcancle() {
      this.detailsdialog = false
    },
    // 详情页面确定按钮
    detailsdialogok() {
      this.getData()
      this.detailsdialog = false
    },
    //列表删除数据按钮
    getdelect(row) {
      let id = row.id
      this.$get("delCertificate", id).then((res) => {
        this.getData()
      });
    },
    cancle11() {
      this.importdialog=false
      clearInterval(this.timer)
      this.timer = null
    }
  },
};

</script>
<style scoped>
@import '../common/font/font.css';

.myCanvasBox {
  position: fixed;
  top: -2000px;
}

.top {
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.content {
  margin-left: 20px;
}

@media screen and (max-width: 600px) {}
</style>



// WEBPACK FOOTER //
// src/views/Policymanagement.vue



// WEBPACK FOOTER //
// src/views/Policymanagement.vue